import { render } from "./CameraGroupsPage.vue?vue&type=template&id=3960b683&ts=true"
import script from "./CameraGroupsPage.vue?vue&type=script&lang=ts"
export * from "./CameraGroupsPage.vue?vue&type=script&lang=ts"

import "./CameraGroupsPage.vue?vue&type=style&index=0&id=3960b683&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__